import React from "react";
import { ListTask, Clipboard } from "react-bootstrap-icons";

export type ViewMode = "complete" | "compact";

interface ViewModeToggleProps {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
}

export const ViewModeToggle: React.FC<ViewModeToggleProps> = ({
  value,
  onChange,
}) => (
  <div className={"packinglist-toggle"}>
    <button
      onClick={() => onChange("compact")}
      className={`packinglist-toggle-btn${value === "compact" ? " active" : ""}`}
      title="Compact view"
      disabled={value === "compact"}
      type="button"
    >
      <Clipboard size={20} />
    </button>
    <button
      onClick={() => onChange("complete")}
      className={`packinglist-toggle-btn${value === "complete" ? " active" : ""}`}
      title="Complete view"
      disabled={value === "complete"}
      type="button"
    >
      <ListTask size={20} />
    </button>
  </div>
);
